import api from '../lib/axios';
import { AxiosError } from 'axios';
import { logger } from '../utils/logger';

export interface MaintenanceStatusResponse {
  enabled: boolean;
  message?: string;
  updatedAt?: string;
  isAllowed?: boolean;
  isAllow?: boolean; // Whitelisted users: true means allow normal access
}

export const getMaintenanceStatus = async (): Promise<MaintenanceStatusResponse | null> => {
  try {
    // Endpoint provided: https://devcore.myeztopup.com/api/maintenance/status
    // We rely on api baseURL from env and call absolute path to ensure correctness.
    const response = await api.get<MaintenanceStatusResponse>('/api/maintenance/status', {
      // withCredentials handled by api instance
    });
    return response.data;
  } catch (error: unknown) {
    const axiosError = error as AxiosError<{ message?: string }>;
    const msg =
      axiosError.response?.data?.message ||
      axiosError.message ||
      'Failed to fetch maintenance status';
    logger.warn('Maintenance status fetch failed:', msg);
    // Fail-open: if status cannot be fetched, allow app to proceed
    return null;
  }
};
